import { Injectable, signal } from '@angular/core';
import { TenantSummary } from '../models/tenant.model';

@Injectable({
  providedIn: 'root'
})
export class SelectedTenantService {
  tenant = signal<TenantSummary | null>(null);

  set(tenant: TenantSummary): void {
    this.tenant.set(tenant);
  }

  clear(): void {
    this.tenant.set(null);
  }
}
